import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  QueryList,
  ViewChildren
} from '@angular/core';
import {MatIcon} from "@angular/material/icon";
import {ApiService} from "../api.service";
import {
  MatAccordion,
  MatExpansionPanel, MatExpansionPanelHeader,
  MatExpansionPanelTitle
} from "@angular/material/expansion";
import { trigger, state, style, transition, animate } from '@angular/animations';
import {MatCard} from "@angular/material/card";
import {NavigationEnd, Router} from "@angular/router";
import {filter, Subscription} from "rxjs";
import {MatFabButton, MatIconButton} from "@angular/material/button";
import {MatTooltip} from "@angular/material/tooltip";
import {DomSanitizer} from "@angular/platform-browser";

@Component({
  selector: 'app-help',
  imports: [
    MatIcon,
    MatAccordion,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    MatCard,
    MatFabButton,
    MatTooltip,
    MatIconButton
  ],
  templateUrl: './help.component.html',
  styleUrl: './help.component.css',
  animations: [
    trigger('slideToggle', [
      state('hidden', style({ transform: 'translateY(100%)', opacity: 0 })),
      state('visible', style({ transform: 'translateY(0)', opacity: 1 })),
      transition('hidden <=> visible', animate('300ms ease-in-out')),
    ])
  ]
})
export class HelpComponent implements OnInit, OnDestroy {
  public help: any;
  public visible: boolean = false;
  public currentPage: string = '';
  private subscription: Subscription|undefined;
  @ViewChildren('helpContent') helpContents!: QueryList<ElementRef>;

  constructor(private api: ApiService, private router: Router, private sanitizer: DomSanitizer) {
  }

  async ngOnInit() {
    this.subscription = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.currentPage = event.urlAfterRedirects;
      });
    this.help = await this.api.getHelp();
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  toggle() {
    console.log(this.currentPage);
    this.visible = !this.visible;
  }

  bypassSanitization(html: string) {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

}
